import { ITransfer, TransferKey } from '@agent/core/contact/transfer/models/transfer';
import { ITransferDeprecatedService } from '@agent/core/contact/transfer/transfer-deprecated.service';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NG1_TRANSFER } from '@commons/core/core.provider.ajs';
import { isArray, isObject, isString } from 'angular';

import { ChanEnum, Logger, UntilDestroy, untilDestroyed } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'mail-transfer-composite-form',
  templateUrl: './mail-transfer-composite-form.component.html',
  styleUrls: ['./mail-transfer-composite-form.component.scss'],
})
export class MailTransferCompositeFormComponent implements OnInit {
  readonly MailIn = ChanEnum.In.Mail;

  @Input() transferKey: TransferKey;
  @Output() targetChanged = new EventEmitter<{ transfer: ITransfer | null }>();

  private transfer: ITransfer | null;
  readonly target = new FormControl([]);

  constructor(
    protected readonly logger: Logger,
    @Inject(NG1_TRANSFER) protected readonly transferDeprecatedService: ITransferDeprecatedService
  ) {
    this.logger = this.logger.forSource('MailTransferCompositeFormComponent');
  }

  private isTargetFreeEmail(target: FormControl): Boolean {
    return !isObject(target.value);
  }

  private isValidTarget(target: FormControl): Boolean {
    if (!target || !isArray(target) || target.length > 1) {
      return false;
    }
    if (!target[0]) {
      return false;
    }
    if (isString(target[0]) && target[0] === '') {
      return false;
    }
    if (isObject(target[0]) && (!target[0].value || !target[0].type)) {
      return false;
    }
    return true;
  }

  ngOnInit() {
    this.transfer = this.transferDeprecatedService.getTransfer(this.transferKey).getOrNull();
    if (!this.transfer) {
      this.logger.error(`transfer not found for key [${JSON.stringify(this.transferKey)}]`);
      return;
    }
    this.target.valueChanges.pipe(untilDestroyed(this)).subscribe(() => {
      if (!this.transfer) {
        this.targetChanged.emit({ transfer: null });
        return;
      }
      if (!this.isValidTarget(this.target.value)) {
        this.transfer.target = null;
        this.logger.error(`unknown target [${this.transfer}]`);
        this.targetChanged.emit({ transfer: this.transfer });
        return;
      }
      const [targetToTransfer] = this.target.value;
      if (!this.isTargetFreeEmail(targetToTransfer)) {
        this.transfer.target = targetToTransfer.value;
        this.transfer.target.uuid = this.transfer.target.id;
        this.transfer.target.type = targetToTransfer.type;
      } else {
        this.transfer.target = targetToTransfer;
      }
      this.targetChanged.emit({ transfer: this.transfer });
    });
  }
}
